export enum ErrorCode {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  NO_FORM_FOUND = 'NO_FORM_FOUND',
  COMMUNICATION_FAILURE = 'COMMUNICATION_FAILURE',
  NO_SITE_KEY_SPECIFIED = 'NO_SITE_KEY_SPECIFIED',
  SITE_KEY_FORMAT_INVALID = 'SITE_KEY_FORMAT_INVALID',
  CAPTCHA_NOT_FOUND = 'CAPTCHA_NOT_FOUND',
  CAPTCHA_NOT_ACCESSIBLE = 'CAPTCHA_NOT_ACCESSIBLE',
  MINIMAL_DATA_MODE_MISMATCH = 'MINIMAL_DATA_MODE_MISMATCH',
  POW_FAILURE = 'POW_FAILURE',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  LOCKED = 'LOCKED',
  LICENSE_FORMAT_INVALID = 'LICENSE_FORMAT_INVALID',
  LICENSE_INVALID = 'LICENSE_INVALID',
  LICENSE_SITE_KEY_MISMATCH = 'LICENSE_SITE_KEY_MISMATCH',
  LICENSE_FEATURE_MISSING_WHITE_LABEL = 'LICENSE_FEATURE_MISSING_WHITE_LABEL',
  LICENSE_FEATURE_MISSING_INVISIBILITY = 'LICENSE_FEATURE_MISSING_INVISIBILITY',
  LICENSE_FEATURE_MISSING_CUSTOMIZABILITY = 'LICENSE_FEATURE_MISSING_CUSTOMIZABILITY',
}
